export var SmsSessionTimerClock;
(function (SmsSessionTimerClock) {
    /** Runs from our send until the client replies, so a waiting client is never nudged. */
    SmsSessionTimerClock["AgentReply"] = "agent_reply";
    /** Silence from either side counts: a client text restarts the wait instead of stopping it. */
    SmsSessionTimerClock["AnyMessage"] = "any_message";
})(SmsSessionTimerClock || (SmsSessionTimerClock = {}));
export const SMS_SESSION_POLICY_DEFAULT_KEY = 'default';
/** For a platform row without a `default` entry; equal to the seeded one. */
export const SMS_SESSION_FALLBACK_GROUP_POLICY = {
    idleSeconds: 86400,
    nudgeAttempts: 0,
    nudgeCopy: '',
    goodbyeCopy: '',
    clock: SmsSessionTimerClock.AnyMessage,
};
/** The session row copies idleSeconds and nudgeAttempts into int4 columns. */
export const SMS_SESSION_POLICY_MAX_NUMBER = 2147483647;
export function isSmsSessionPolicyNumber(value) {
    return (typeof value === 'number' &&
        Number.isSafeInteger(value) &&
        value >= 0 &&
        value <= SMS_SESSION_POLICY_MAX_NUMBER);
}
/** All or nothing: one bad entry rejects the whole value, so a reader never runs half of it. */
export function parseSmsSessionPolicyByGroup(raw) {
    let parsed;
    try {
        parsed = JSON.parse(raw);
    }
    catch {
        throw new Error('the value is not valid JSON');
    }
    if (!isPlainObject(parsed)) {
        throw new Error('the value must be a JSON object keyed by assignee group id');
    }
    return Object.fromEntries(Object.entries(parsed).map(([key, entry]) => [key, parseGroupPolicy(key, entry)]));
}
export function resolveSmsSessionGroupPolicy(assigneeGroupId, policies) {
    const { partner, platform } = policies;
    const groupPolicy = assigneeGroupId === null
        ? undefined
        : (partner?.[assigneeGroupId] ?? platform?.[assigneeGroupId]);
    return (groupPolicy ??
        platform?.[SMS_SESSION_POLICY_DEFAULT_KEY] ??
        SMS_SESSION_FALLBACK_GROUP_POLICY);
}
function parseGroupPolicy(key, entry) {
    if (!isPlainObject(entry)) {
        throw new Error(`entry "${key}" must be an object`);
    }
    return {
        idleSeconds: readPolicyNumber(key, 'idleSeconds', entry.idleSeconds),
        nudgeAttempts: readPolicyNumber(key, 'nudgeAttempts', entry.nudgeAttempts),
        nudgeCopy: readCopy(key, 'nudgeCopy', entry.nudgeCopy),
        goodbyeCopy: readCopy(key, 'goodbyeCopy', entry.goodbyeCopy),
        clock: readClock(key, entry.clock),
    };
}
function readPolicyNumber(key, field, value) {
    if (!isSmsSessionPolicyNumber(value)) {
        throw new Error(`entry "${key}": ${field} must be a whole number from 0 to ${SMS_SESSION_POLICY_MAX_NUMBER}`);
    }
    return value;
}
function readCopy(key, field, value) {
    if (typeof value !== 'string') {
        throw new Error(`entry "${key}": ${field} must be a string`);
    }
    return value.trim();
}
function readClock(key, value) {
    const clocks = Object.values(SmsSessionTimerClock);
    if (!clocks.includes(value)) {
        throw new Error(`entry "${key}": clock must be one of ${clocks.join(', ')}`);
    }
    return value;
}
function isPlainObject(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
